import { Action, createReducer, on } from '@ngrx/store';
import { StepInterface } from 'sp-arch-lib';
import * as bootActions from 'sp-mark/feature-modules/boot/redux/boot.actions';
import { LocalUnit, Merchant } from 'sp-ui-lib';

export interface BootState {
  currentStepIndex: number;
  flagInitializationCompleted: boolean;
  flagLocalUnitsCompletlyDisabled: boolean;
  flagLocalUnitsDisabled: boolean;
  localUnits: LocalUnit[];
  loggedMerchant: Merchant;
  steps: StepInterface[];
}

export const initialState: BootState = {
  currentStepIndex: undefined,
  flagInitializationCompleted: false,
  flagLocalUnitsCompletlyDisabled: false,
  flagLocalUnitsDisabled: false,
  localUnits: [],
  loggedMerchant: undefined,
  steps: [],
};

const routerReducer = createReducer(
  initialState,
  on(bootActions.loginSuccess, (state, props) => ({
    ...state,
    userInformation: props.userInformation
  })),
  on(bootActions.retrieveLocalUnitsSuccess, (state, props) => ({
    ...state,
    localUnits: props.localUnits
  })),
  on(bootActions.toggleLocalUnit, (state, props) => ({
    ...state,
    localUnits: state.localUnits.map(unit => ({
      ...unit,
      flagSelected: checkToggleLocalUnit(state, unit, props)
    }))
  })),
  on(bootActions.toggleLocalUnitById, (state, props) => ({
    ...state,
    localUnits: state.localUnits.map(unit => ({
      ...unit,
      flagSelected: unit.id === props.id ? true : false
    }))
  })),
  on(bootActions.toggleAllLocalUnits, state => ({
    ...state,
    localUnits: state.localUnits.map(unit => ({
      ...unit,
      flagSelected: false
    }))
  })),
  on(bootActions.checkStepsSuccess, state => ({
    ...state,
    flagInitializationCompleted: true
  })),
  on(bootActions.retrieveLoggedMerchantSuccess, (state, props) => ({
    ...state,
    loggedMerchant: props.merchant
  })),
  on(bootActions.toggleLocalUnitsDisable, (state, props) => ({
    ...state,
    flagLocalUnitsDisabled: props.flagLocalUnitsDisabled
  })),
  on(bootActions.toggleLocalUnitsCompletlyDisable, (state, props) => ({
    ...state,
    flagLocalUnitsCompletlyDisabled: props.flagLocalUnitsCompletlyDisabled
  })),
  on(bootActions.checkStepsSuccess, (state, props) => ({
    ...state,
    steps: props.steps
  })),
  on(bootActions.setCurrentStepIndex, (state, props) => ({
    ...state,
    currentStepIndex: props.currentStepIndex
  })),
);

export function reducer(state: BootState | undefined, action: Action) {
  return routerReducer(state, action);
}

function isLocalUnitSelected(state: BootState): boolean {
  return state.localUnits.filter(element => element.flagSelected).length !== 1;

}

function checkToggleLocalUnit(state, unit, props): boolean | {} {
  if (state.flagLocalUnitsDisabled) {
    return unit.id === props.localUnit.id ? (isLocalUnitSelected(state) ? !unit.flagSelected : {}) : false;
  } else {
    return unit.id === props.localUnit.id ? (isLocalUnitSelected(state) ? !unit.flagSelected : {}) : unit.flagSelected;
  }
}
